import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { Fragment } from 'react/jsx-runtime';
import { Cell } from '@recargas-dominicanas/core/components';
import { formatCurrency, formatPhone } from '@recargas-dominicanas/core/utils';
import { type IBusiness, type ICustomer } from '@recargas-dominicanas/core/types';
import { CellIcon, Menu, TableRow } from '@recargas-dominicanas/core/components';
import { MenuOption } from '../../../components/menu-option/menu-option.component';
import { ConfirmModal } from '../../../components/confirm-modal/confirm-modal.component';
import { style } from './business-item.module.css';
import { BusinessApi } from '@recargas-dominicanas/core/adminApi';
import { BusinessStore } from '../../../store/businessStore';

interface Props {
  business: IBusiness;
}

export function BusinessItem(props: Props) {

  const { business } = props;

  const navigate = useNavigate();

  const menuIconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openArchiveModal, setOpenArchiveModal] = useState(false);

  function handleClick() {
    navigate(`/customer/${business.id}`);
  }

  async function handleArchive() {
    try {
      await BusinessApi.delete(business.id);
      await BusinessStore.fetchAll();
    } catch (err) {
      console.error(err);
    }
  }

  function statusToTitle(status: ICustomer['status']) {
    switch (status) {
      case 'new': return 'Nuevo';
      case 'active': return 'Activo';
      case 'inactive': return 'Inactivo';
      case 'lost': return 'Perdido';
    }
  }

  function statusToColor(status: ICustomer['status']) {
    switch (status) {
      case 'new': return 'gray';
      case 'active': return 'green';
      case 'inactive': return 'yellow';
      case 'lost': return 'red';
    }
  }

  return (
    <Fragment>
      <TableRow
        onClick={handleClick}>
        <Cell className={style.cell} weight='medium' text={business.id}/>
        <Cell className={style.cell} weight='medium' text={business.name}/>
        <Cell className={style.cell} text={business.customer?.name}/>
        <Cell className={style.cell} text={formatPhone(business.customer.phone)}/>
        <Cell className={style.cell} text={business.city}/>
        <Cell 
          className={style.cell}
          weight='medium' 
          color={statusToColor(business.customer.status)} 
          text={statusToTitle(business.customer.status)}/>
        <Cell 
          className={style.cell}
          weight='medium' 
          color='green' 
          text={formatCurrency(business.balance)}/>
        <Cell 
          className={style.cell}
          weight='medium' 
          color='green' 
          text={formatCurrency(business.sales)}/>
        <CellIcon refIcon={menuIconRef} onClick={() => setOpenMenu(true)}/>
      </TableRow>
      <Menu 
        open={openMenu} 
        anchor={menuIconRef}
        onClose={() => setOpenMenu(false)}>
        <MenuOption
          text='Archivar' 
          onClick={() => setOpenArchiveModal(true)}/>
      </Menu>
      <ConfirmModal
        open={openArchiveModal}
        title='Archivar negocio'
        disableConfirmation={true}
        onConfirm={handleArchive}
        onClose={() => setOpenArchiveModal(false)}>
        <div className={style.confirmModalContent}>
          Estas seguro de quere archivar el negocio <b>{business.name}</b>.
        </div>
      </ConfirmModal>
    </Fragment>
  );
}
